import { defineStore } from 'pinia'

export const useProductBuyboxStore = defineStore('product-buybox', () => {
  const { API_ENDPOINTS } = useApiEndpoints()
  const router = useRouter()

  const buyboxData = ref(null)
  const loading = ref(false)

  const fetchBuyboxData = async (productUrl) => {
    const queries = router.currentRoute.value.query
    loading.value = true
    try {
      const response = await useBaseOFetchWithAuth(
        API_ENDPOINTS.public.products.buybox(),
        {
          params: {
            product_url: productUrl,
            ...queries
          }
        }
      )
      buyboxData.value = response
    } catch (error) {
      throw error
    } finally {
      loading.value = false
    }
  }

  const getters = {
    isBasic: computed(() => buyboxData.value?.type === 'basic'),
    isVariant: computed(() => buyboxData.value?.type === 'variant')
  }

  return {
    buyboxData,
    loading,
    fetchBuyboxData,
    isBasic: getters.isBasic,
    isVariant: getters.isVariant
  }
})
